<template>
  <div class="navbar-container d-flex content align-items-center">

    <!-- Nav Menu Toggler -->
    <ul
      v-if="!isNavMenuHidden"
      class="nav navbar-nav d-xl-none"
    >
      <li class="nav-item">
        <b-link
          class="nav-link"
          @click="toggleVerticalMenuActive"
        >
          <GjIcon
            name="Menu"
            size="21"
          />
        </b-link>
      </li>
    </ul>

    <!-- Left Col -->
    <div

      class="bookmark-wrapper flex-grow-1 d-none d-lg-flex flex-row justify-items-start align-items-center"
    >
      <div
        v-if="screen > 1199"
        :style="logoWidth"
      >
        <b-link
          class="navbar-brand"
          :to="{name: 'dashboard', params: { projectId: activeProjectId }}"
        >
          <span class="brand-logo">
            <b-img
              :src="vpLogo"
              alt="logo"
              style="height: 20px; width: auto; max-width: 200px;"
            />
          </span>
        </b-link>
      </div>
      <nav
        v-if="screen > 991"
        class="pl-50"
        aria-label="Breadcrumb"
      >
        <ul
          role="list"
          class="d-flex align-items-center text-white pl-0 mx-0 mt-1"
        >
          <li
            v-for="(breadcrumb, index) in $route.meta.breadcrumb"
            :key="`breadcrumb${index}`"
            class="d-flex align-items-center text-white"
          >
            <b-spinner
              v-if="breadcrumb.dynamic && !breadcrumbTitle && breadcrumbTitle !== null && breadcrumbTitle !== undefined"
              class="d-flex text-white m-0 p-0"
              small
            />
            <component
              :is="breadcrumb.disabled ? 'span' : 'router-link'"
              v-else
              :disabled="breadcrumb.disabled"
              :to="{ name: breadcrumb.to }"
              class="text-xs truncate w-auto cursor-default text-white"
              :class="{
                'font-semibold': breadcrumb.active,
                '!cursor-pointer': !breadcrumb.disabled,
                'text-truncate pl-0 ml-0 custom-width': breadcrumb.dynamic
              }"
            >
              {{ breadcrumb.dynamic ? (breadcrumbTitle !== null && breadcrumbTitle !== undefined ? breadcrumbTitle : breadcrumb.text) : breadcrumb.text }}
            </component>
            <GjIcon
              v-if="index < $route.meta.breadcrumb.length - 1"
              name="ArrowRight"
              size="20"
            />
          </li>
        </ul>
      </nav>

    </div>
    <b-link
      v-if="$route.meta.hiddenSidebar && $store.state.app.windowWidth < 1200"
      class="navbar-brand m-0"
      :to="{name: 'dashboard', params: { projectId: activeProjectId }}"
    >
      <span class="brand-logo">
        <img
          :src="vpLogo"
          alt="logo"
          style="height: 16px; width: 32px;"
        >
      </span>
    </b-link>

    <b-navbar-nav class="nav align-items-center ml-auto col p-0 justify-content-end">
      <!-- <locale /> -->
      <!-- <dark-Toggler class="d-none d-lg-block" /> -->
      <!-- <search-bar /> -->
      <!-- <cart-dropdown /> -->
      <!-- <notification-dropdown /> -->
      <b-dropdown
        variant="link"
        toggle-class="text-decoration-none"
        menu-class="p-0"
        no-caret
        class="p-0 mr-1"
        size="sm"
        right
      >
        <template v-slot:button-content>
          <GjIcon
            name="Question"
            size="24"
            class="text-white"
          />
        </template>
        <b-dropdown-item
          href="https://vp.gjirafa.tech/documentation/user-guide/intro"
          target="_blank"
          class="d-flex p-0 m-0 text-secondary text-main"
        >
          <GjIcon
            name="Docs"
            class="mr-0 mr-lg-50"
          />
          User guide
        </b-dropdown-item>
        <b-dropdown-item
          class="d-flex p-0 m-0 text-secondary text-main"
          target="_blank"
          href="https://vp.gjirafa.tech/documentation/"
        >
          <GjIcon
            name="Docs"
            class="mr-0 mr-lg-50"
          />
          Developer guide
        </b-dropdown-item>
      </b-dropdown>
      <user-dropdown />
    </b-navbar-nav>
  </div>
</template>

<script>
import { BLink, BNavbarNav } from 'bootstrap-vue'
import { $themeConfig } from '@themeConfig'
import useAppConfig from '@core/app-config/useAppConfig'
// import Locale from './components/Locale.vue'
// import SearchBar from './components/SearchBar.vue'
// import DarkToggler from './components/DarkToggler.vue'
// import CartDropdown from './components/CartDropdown.vue'
// import NotificationDropdown from './components/NotificationDropdown.vue'

import UserDropdown from './components/UserDropdown.vue'

export default {
  components: {
    BLink,

    // Navbar Components
    BNavbarNav,
    // Locale,
    // DarkToggler,
    // CartDropdown,
    // NotificationDropdown,
    UserDropdown,
  },
  props: {
    toggleVerticalMenuActive: {
      type: Function,
      default: () => {},
    },
  },
  data() {
    return {
      screen: 0,
    }
  },
  computed: {
    activeProjectId() {
      return this.$store.getters['projectModule/getActiveProjectId']
    },
    breadcrumbTitle() {
      return this.$store.getters['app/breadcrumbsTitle']
    },
    logoWidth() {
      const { windowWidth } = this.$store.state.app
      const { isSidebarCollapsed } = this.$store.state.projectModule

      if (windowWidth < 1199 || isSidebarCollapsed) {
        return 'width: 50px'
      }
      return 'width: 260px'
    },
  },
  setup() {
    // App Name
    const { appName, vpLogo } = $themeConfig.app

    const {
      isNavMenuHidden,
    } = useAppConfig()

    return {
      // App Name
      appName,
      vpLogo,
      isNavMenuHidden,
    }
  },
  mounted() {
    window.addEventListener('resize', () => {
      this.windowWidth()
    })
    if (!Object.keys(this.$route.meta).length) this.$store.commit('userModule/UPDATE_ISLOADING', false)
  },
  created() {
    // eslint-disable-next-line no-restricted-globals
    this.screen = screen.width
  },
  methods: {
    windowWidth() {
      // eslint-disable-next-line no-restricted-globals
      this.screen = screen.width
    },
  },
}
</script>

<style lang="scss" scoped>
.breadcrumb-item.active {
  span {
    width: auto;
    max-width: 200px;
    text-overflow: ellipsis;
    white-space: nowrap;
    overflow: hidden;
  }
}

.custom-width {
  width: 250px !important;
}
</style>
